<p>complete-user-sign-up works!</p>
